const loginRequest = {
  scopes: ['User.Read'],
  prompt: 'select_account',
}

export default loginRequest
